(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["treasure-find-detail"]) return;
  try {
    
(function () {
  function initRoot(root) {
    if (!root || root.__tgdInit) return;
    root.__tgdInit = true;

    var dialog = root.querySelector('[data-tgd-dialog]');
    if (!dialog) return;
    var imgEl = dialog.querySelector('[data-tgd-img]');
    var counterEl = dialog.querySelector('[data-tgd-counter]');
    var dataHost = root.querySelector('.tgd-media__data');
    var slides = dataHost ? Array.prototype.slice.call(dataHost.querySelectorAll('.tgd-slide')).map(function (n) {
      return { src: n.getAttribute('data-src'), srcset: n.getAttribute('data-srcset'), alt: n.getAttribute('data-alt') };
    }) : [];
    var current = 0;
    var lastTrigger = null;

    function focusables() {
      return Array.prototype.slice.call(dialog.querySelectorAll('button:not([disabled])'))
        .filter(function (el) { return el.offsetParent !== null || el === document.activeElement; });
    }
    function show(i) {
      if (!slides.length) return;
      current = (i + slides.length) % slides.length;
      var s = slides[current];
      imgEl.src = s.src;
      if (s.srcset) imgEl.setAttribute('srcset', s.srcset); else imgEl.removeAttribute('srcset');
      imgEl.alt = s.alt || '';
      if (counterEl) counterEl.textContent = (current + 1) + ' / ' + slides.length;
    }
    function open(trigger) {
      if (!slides.length) return;
      lastTrigger = trigger;
      show(parseInt(trigger.getAttribute('data-tgd-index'), 10) || 0);
      dialog.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      var f = focusables();
      if (f.length) f[0].focus();
    }
    function close() {
      dialog.hidden = true;
      document.documentElement.style.overflow = '';
      if (lastTrigger) lastTrigger.focus();
      lastTrigger = null;
    }

    root.addEventListener('click', function (ev) {
      var trigger = ev.target.closest('[data-tgd-lightbox]');
      if (trigger && root.contains(trigger)) { ev.preventDefault(); open(trigger); }
    });
    dialog.addEventListener('click', function (ev) {
      if (ev.target.closest('[data-tgd-close]')) { close(); }
      else if (ev.target.closest('[data-tgd-prev]')) { show(current - 1); }
      else if (ev.target.closest('[data-tgd-next]')) { show(current + 1); }
    });
    document.addEventListener('keydown', function (ev) {
      if (dialog.hidden) return;
      if (ev.key === 'Escape') { close(); }
      else if (ev.key === 'ArrowLeft') { show(current - 1); }
      else if (ev.key === 'ArrowRight') { show(current + 1); }
      else if (ev.key === 'Tab') {
        var f = focusables();
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (ev.shiftKey && document.activeElement === first) { ev.preventDefault(); last.focus(); }
        else if (!ev.shiftKey && document.activeElement === last) { ev.preventDefault(); first.focus(); }
      }
    });
  }

  function initAll() { document.querySelectorAll('[data-tgd-root]').forEach(initRoot); }
  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-tgd-root]');
    if (root) initRoot(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["treasure-gallery"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initRoot(root) {
    if (!root || root.__tgInit) return;
    root.__tgInit = true;

    var grid = root.querySelector('[data-tg-grid]');
    var moreWrap = root.querySelector('[data-tg-more]');
    var moreBtn = root.querySelector('[data-tg-more-btn]');
    var chipWrap = root.querySelector('[data-tg-filters]');
    var initial = parseInt(root.getAttribute('data-tg-initial'), 10) || 12;
    var cards = grid ? Array.prototype.slice.call(grid.querySelectorAll('[data-tg-card]')) : [];

    var activeBrand = 'all';
    var visible = initial;

    function matches(card) {
      if (activeBrand === 'all') return true;
      return (card.getAttribute('data-brand') || '') === activeBrand;
    }

    function render() {
      var shown = 0;
      var totalMatch = 0;
      cards.forEach(function (card) {
        if (matches(card)) {
          totalMatch++;
          if (shown < visible) {
            card.classList.remove('is-hidden');
            shown++;
          } else {
            card.classList.add('is-hidden');
          }
        } else {
          card.classList.add('is-hidden');
        }
      });
      if (moreWrap) moreWrap.hidden = totalMatch <= visible;
    }

    // Expand / collapse stories
    grid && grid.addEventListener('click', function (ev) {
      var btn = ev.target.closest('[data-tg-expand]');
      if (!btn) return;
      var story = btn.previousElementSibling;
      if (!story) return;
      var shortEl = story.querySelector('.tg-story__text:not(.tg-story__text--full)');
      var fullEl = story.querySelector('.tg-story__text--full');
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      if (shortEl) shortEl.hidden = !expanded;
      if (fullEl) fullEl.hidden = expanded;
      btn.setAttribute('aria-expanded', String(!expanded));
      btn.textContent = expanded ? 'Read more' : 'Show less';
    });

    // Filter chips
    if (chipWrap) {
      chipWrap.addEventListener('click', function (ev) {
        var chip = ev.target.closest('[data-tg-chip]');
        if (!chip) return;
        activeBrand = chip.getAttribute('data-tg-chip');
        visible = initial; // filtering resets the reveal count
        chipWrap.querySelectorAll('[data-tg-chip]').forEach(function (c) {
          var on = c === chip;
          c.classList.toggle('is-active', on);
          c.setAttribute('aria-pressed', String(on));
        });
        render();
      });
    }

    // Show more
    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        visible += initial;
        render();
      });
    }

    render();

    /* ---------------- Lightbox ---------------- */
    var dialog = root.querySelector('[data-tg-dialog]');
    if (dialog) {
      var imgEl = dialog.querySelector('[data-tg-img]');
      var counterEl = dialog.querySelector('[data-tg-counter]');
      var slides = [];
      var current = 0;
      var lastTrigger = null;

      function focusables() {
        return Array.prototype.slice.call(
          dialog.querySelectorAll('button:not([disabled])')
        ).filter(function (el) { return el.offsetParent !== null || el === document.activeElement; });
      }

      function show(i) {
        if (!slides.length) return;
        current = (i + slides.length) % slides.length;
        var s = slides[current];
        imgEl.src = s.src;
        if (s.srcset) imgEl.setAttribute('srcset', s.srcset); else imgEl.removeAttribute('srcset');
        imgEl.alt = s.alt || '';
        if (counterEl) counterEl.textContent = (current + 1) + ' / ' + slides.length;
      }

      function open(trigger) {
        var host = trigger.closest('.tg-card__media, .tg-featured__media');
        var data = host ? host.querySelector('.tg-media__data') : null;
        if (!data) return;
        slides = Array.prototype.slice.call(data.querySelectorAll('.tg-slide')).map(function (n) {
          return { src: n.getAttribute('data-src'), srcset: n.getAttribute('data-srcset'), alt: n.getAttribute('data-alt') };
        });
        if (!slides.length) return;
        lastTrigger = trigger;
        show(parseInt(trigger.getAttribute('data-tg-index'), 10) || 0);
        dialog.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        var f = focusables();
        if (f.length) f[0].focus();
      }

      function close() {
        dialog.hidden = true;
        document.documentElement.style.overflow = '';
        if (lastTrigger) lastTrigger.focus();
        lastTrigger = null;
      }

      root.addEventListener('click', function (ev) {
        var trigger = ev.target.closest('[data-tg-lightbox]');
        if (trigger && root.contains(trigger)) { ev.preventDefault(); open(trigger); }
      });

      dialog.addEventListener('click', function (ev) {
        if (ev.target.closest('[data-tg-close]')) { close(); }
        else if (ev.target.closest('[data-tg-prev]')) { show(current - 1); }
        else if (ev.target.closest('[data-tg-next]')) { show(current + 1); }
      });

      document.addEventListener('keydown', function (ev) {
        if (dialog.hidden) return;
        if (ev.key === 'Escape') { close(); }
        else if (ev.key === 'ArrowLeft') { show(current - 1); }
        else if (ev.key === 'ArrowRight') { show(current + 1); }
        else if (ev.key === 'Tab') {
          var f = focusables();
          if (!f.length) return;
          var first = f[0], last = f[f.length - 1];
          if (ev.shiftKey && document.activeElement === first) { ev.preventDefault(); last.focus(); }
          else if (!ev.shiftKey && document.activeElement === last) { ev.preventDefault(); first.focus(); }
        }
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-tg-root]').forEach(initRoot);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-tg-root]');
    if (root) initRoot(root);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
